import CalendarComponent from './CalendarComponent.container';

export default CalendarComponent;
